import { Injectable, booleanAttribute } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './auth.guard';

@Injectable({
    providedIn: 'root'
})
export class ConditionalMsalGuard implements CanActivate {
    constructor(private msalGuard: MsalGuard, private authGuard: AuthGuard) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Exclude login/auth routes from MSAL Guard to prevent redirect loops
        const isLoginRoute = state.url.includes('/auth/sign-in') || 
                            state.url.includes('/auth/sign-up') || 
                            state.url.includes('addlogin') ||
                            state.url.includes('/auth');
        
        if (isLoginRoute) {
            console.log('ConditionalMsalGuard - Login route detected, skipping MSAL Guard:', state.url);
            // Allow access to login routes without MSAL guard
            return true;
        }
        
        // Your condition to decide whether to apply MsalGuard or not
        const shouldApplyMsalGuard = localStorage.getItem('ad_attempt');
        console.log('ConditionalMsalGuard - ad_attempt:', shouldApplyMsalGuard);
        console.log('ConditionalMsalGuard - Route:', state.url);
        
        if (shouldApplyMsalGuard == "true") {
            console.log('ConditionalMsalGuard - Applying MSAL Guard');
            const result = this.msalGuard.canActivate(next, state);
            console.log('ConditionalMsalGuard - MSAL Guard result:', result);
            return result;
        } else {
            console.log('ConditionalMsalGuard - Applying Auth Guard');
            return this.authGuard.canActivate(next, state);
        }
    }
}
